import httpClient from './httpClient';
import API_CONFIG from './config';

const { AUTH } = API_CONFIG.ENDPOINTS;

const authApi = {
  signup: (data) => httpClient.post(AUTH.SIGNUP, data),

  login: (data) => httpClient.post(AUTH.LOGIN, data),

  sendOtp: (data) => httpClient.post(AUTH.SEND_OTP, data),

  verifyOtp: (data) => httpClient.post(AUTH.VERIFY_OTP, data),

  forgotPassword: (data) => httpClient.post(AUTH.FORGOT_PASSWORD, data),

  resetPassword: (data) => httpClient.post(AUTH.RESET_PASSWORD, data),

  refreshToken: (data) => httpClient.post(AUTH.REFRESH, data),

  logout: () => httpClient.post(AUTH.LOGOUT),

  socialLogin: (data) => httpClient.post(AUTH.SOCIAL_LOGIN, data),
};

export default authApi;
